exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.box[data-v-686b1c8d] {\n    height: 0;\n    padding-top: 90%;\n    margin: 5%;\n    border-radius: 5%;\n    background-color: #BBADA0;\n    z-index: 0;\n}\n.number[data-v-686b1c8d]{\n    position: absolute;\n    margin: 5%;\n    border-radius: 5%;\n    text-align: center;\n    font-weight: bold;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n}\n.shadow-number[data-v-686b1c8d]{\n    position: absolute;\n    margin: 5%;\n    border-radius: 5%;\n    text-align: center;\n    font-weight: bold;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n}\n", ""]);

// exports
